import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class MarkupCriteria {
  public account: string;
  public clientCd: string;
  public base: string;
  public nonBase: string;
  public fixedCcy: string;
  public clientBuysFixed: boolean;
  public requestOrderType: CubiqTS.RequestOrderType;
  public product: CubiqTS.Product;
  public tenor: CubiqTS.Tenor;
  public valueDate: CubiqTS.StandardDateImpl;
  public tradingSource: string;
  public requestRate: string;
  public orderAmount: string;
  public benchmarkCode: string;
  public benchmarkDts: CubiqTS.Moment;
  public algoStrategyName: string;
}
